import { Badge } from '@mantine/core';
import type { HealthStatus } from '../types';

type HealthBadgeProps = {
  status: HealthStatus;
};

const STATUS_CONFIG: Record<HealthStatus, { variant: string; label: string }> = {
  HEALTHY: { variant: 'success', label: 'Healthy' },
  DELAYED: { variant: 'warning', label: 'Delayed' },
  CRITICALLY_DELAYED: { variant: 'error', label: 'Delayed' },
  NOT_CONFIGURED: { variant: 'grey', label: 'Not configured' },
};

export default function HealthBadge({ status }: HealthBadgeProps) {
  const { variant, label } = STATUS_CONFIG[status];

  return (
    <Badge variant={variant} size="lg">
      {label}
    </Badge>
  );
}
